// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateStructureModale_container__cdUpy","input":"CreateStructureModale_input__2HCX1"};